/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ voice: NonNullable<unknown> }} Why_Listening_Demo_VoiceInputs */

const en_why_listening_demo_voice = /** @type {(inputs: Why_Listening_Demo_VoiceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Listening · ${i?.voice} voice`)
};

const es_why_listening_demo_voice = /** @type {(inputs: Why_Listening_Demo_VoiceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Listening · voz de ${i?.voice}`)
};

/**
* | output |
* | --- |
* | "Listening · {voice} voice" |
*
* @param {Why_Listening_Demo_VoiceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_demo_voice = /** @type {((inputs: Why_Listening_Demo_VoiceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Demo_VoiceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_demo_voice(inputs)
	return en_why_listening_demo_voice(inputs)
});